// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3S_V5","requiredAsterisk":"Info_requiredAsterisk__3O9KS"};